
const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getAllDesksApi = async (page = 1, perPage = 15) => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(
            `${API_BASE_URL}/admin/user/desks?page=${page}&per_page=${perPage}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || 'Ошибка при получении списка десков');
        }

        const data = await response.json();
        console.log(data)
        return data;
    } catch (error) {
        console.error('Ошибка при получении списка десков:', error);
        throw error;
    }
};